module.exports = __webpack_public_path__ + "media/images/pages/img_culture_area_03-22f28d1669d3b70963f32555cb07ff32.jpg";